import { MedicalImageRender } from '@/shared/graphics/medicalImageRender/MedicalImageRender';

import type { MPRPaneLayoutViewer } from '../config';

export const MPR_PANE_LAYOUT_PAGE_VIEWER: MPRPaneLayoutViewer = {
  getPaneLayout: () => MedicalImageRender.getFullHeadMPRPaneLayout() ?? null,
  setPaneLayout: (layout) =>
    MedicalImageRender.setFullHeadMPRPaneLayout(layout),
};
